import {
  Button,
  Heading,
  ListItem,
  OrderedList,
  Stack,
} from '@chakra-ui/react';
import { FC } from 'react';
import upperFirst from 'lodash/fp/upperFirst';
import { StepRuler } from './StepRuler';
import { useMobileCheckDepositContext } from '../../context';
import { Camera, CheckBack, CheckFront } from '../../../../assets';
import { DepositCheckOptions } from '../../../../utils';

export interface CaptureCheckProps {
  checkType: string;
}

export const CaptureCheck: FC<CaptureCheckProps> = ({ checkType = '' }) => {
  const {
    data: {
      steps: { activeStep, prevSteps },
    },
    commands: { handleCapture, handleStep },
  } = useMobileCheckDepositContext();

  const frontCheck = checkType === 'front';
  const step = frontCheck ? 2 : 3;
  const isActive = frontCheck ? activeStep === 2 : activeStep === 3;

  const Icon = frontCheck ? CheckFront : CheckBack;

  const hasStep = prevSteps.includes(step);
  const handleCaptureCheck = () => {
    if (hasStep) {
      handleStep(step);
    }
  };

  return isActive ? (
    <Stack direction="row" spacing={4}>
      <StepRuler icon={Icon} />
      <Stack w="full" spacing={4}>
        <Heading fontSize="xl" color="brand.secondary.swatch4">
          Capture Check {upperFirst(checkType)}
        </Heading>
        <OrderedList spacing={4}>
          <ListItem>
            Use a dark, solid background with good, even lighting
          </ListItem>
          <ListItem>
            Ensure the entire check is visible from edge to edge in your photo
          </ListItem>
        </OrderedList>
        <Button
          colorScheme="blue"
          leftIcon={<Camera />}
          onClick={() => handleCapture((DepositCheckOptions as any)[checkType])}
        >
          Capture photo
        </Button>
      </Stack>
    </Stack>
  ) : (
    <Button
      p={0}
      colorScheme="blue"
      variant="ghost"
      onClick={handleCaptureCheck}
      leftIcon={<Icon boxSize={6} />}
      textDecoration={hasStep ? 'underline' : 'none'}
    >
      Capture Check {upperFirst(checkType)}
    </Button>
  );
};
